export const measuringToolController = (
    measuringToolPolyline: any,
    isUsingMeasuringTool: boolean,
    measuringToolDrawn: boolean,
) => {
    if (!measuringToolDrawn) {
        if (isUsingMeasuringTool) {
            measuringToolPolyline && measuringToolPolyline.enable();
        } else if (!isUsingMeasuringTool) {
            measuringToolPolyline && measuringToolPolyline.disable();
        }
    }
    if (measuringToolDrawn) {
        measuringToolPolyline && measuringToolPolyline.enable();
        if (!isUsingMeasuringTool) {
            measuringToolPolyline.disable();
        }
    }
};
